var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLaptop = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.791 12.382V1.527c0-.842-.717-1.527-1.6-1.527H2.808c-.882 0-1.6.685-1.6 1.527v10.855H0v1.588L1.14 15h17.72L20 13.97v-1.588h-1.209zM2.008 1.527c0-.42.36-.763.8-.763h14.383c.441 0 .8.342.8.763v10.855H2.008V1.527zM19.2 13.641l-.66.595H1.46l-.66-.595v-.496h18.4v.496z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 2v10h14V2H3zm13 9H4V3h12v8z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLaptop, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/laptop.c154fff2.svg";
export { ForwardRef as ReactComponent };